import { Link } from 'react-router-dom';
import type { VideoItem } from '@/mocks/videos';

interface VideoCardProps {
  video: VideoItem;
}

const VideoCard = ({ video }: VideoCardProps) => {
  const formatViews = (views: number) => {
    if (views >= 10000) {
      return `${(views / 10000).toFixed(1)}万`;
    }
    return views.toString();
  };

  return (
    <Link
      to={`/article/${video.id}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-video bg-background-200">
        <img
          src={video.thumbnail}
          alt={video.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50 transform scale-75 group-hover:scale-100 transition-transform duration-300">
            <i className="ri-play-fill text-2xl ml-0.5"></i>
          </div>
        </div>
        <div className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-black/70 text-background-50 text-xs">
          {video.duration.includes('分钟') || video.duration === 'HD高清' ? video.duration.replace('分钟', '') : video.duration}
        </div>
        {video.isHot && (
          <div className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
            热门
          </div>
        )}
        {video.isNew && !video.isHot && (
          <div className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-medium">
            新上
          </div>
        )}
      </div>

      <div className="mt-3">
        <h3 className="text-sm font-medium text-foreground-900 truncate group-hover:text-primary-600 transition-colors duration-200">
          {video.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5 text-xs text-foreground-500">
          <span className="flex items-center gap-0.5">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
            {video.rating}
          </span>
          <span className="text-foreground-300">|</span>
          <span>{video.year}</span>
          <span className="text-foreground-300">|</span>
          <span>{formatViews(video.views)}次播放</span>
        </div>
        <div className="flex flex-wrap gap-1 mt-1.5">
          {video.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="px-1.5 py-0.5 rounded text-[10px] bg-secondary-100 text-secondary-700"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
};

export default VideoCard;